import { Flex, Text } from '@chakra-ui/react';
import { IconPlusLarge } from 'central-icons/IconPlusLarge';

import type { Scenario, SelectedGeo } from '../types';
import { ScenarioPopover } from './ScenarioPopover';

interface ScenarioPanelProps {
  /** The page's primary geo — the default for a new scenario, never mutated here. */
  defaultGeo: SelectedGeo | null;
  onAddScenario: (scenario: Scenario) => void;
  /** Optional controlled open state (variant 1 opens it from the map). */
  isOpen?: boolean;
  onOpenChange?: (open: boolean) => void;
}

export function ScenarioPanel({
  defaultGeo,
  onAddScenario,
  isOpen,
  onOpenChange,
}: ScenarioPanelProps) {
  return (
    <ScenarioPopover
      defaultGeo={defaultGeo}
      submitLabel="Add"
      confirmTestId="add-scenario-confirm"
      onSubmit={(draft) => onAddScenario({ id: `${Date.now()}`, ...draft })}
      isOpen={isOpen}
      onOpenChange={onOpenChange}
    >
      <Flex
        align="center"
        gap="8px"
        cursor="pointer"
        color="navyBlue.500"
        data-testid="add-scenario-button"
      >
        <IconPlusLarge size={16} />
        <Text fontSize="14px" fontWeight="600">
          Scenario
        </Text>
      </Flex>
    </ScenarioPopover>
  );
}
